import gql from "graphql-tag";

export const brandPrivateFragment = gql`
  fragment BrandPrivateFragment on BrandPrivate {
    id
    name
    legalName
    code
    storeType
    vendorId
    mobileNo
    completeAddress
    customerCode
    isLargeTaxpayer
    isPayoutEligible
    status
    tinNo
    signatoryName
    signatoryEmail
    signatoryDesignation
    signatoryMobileNo
    bankName
    bankAccountName
    bankAccountNo
    financeName
    financeEmail
    financeMobileNo
    storeType
    vendorCode
    swornDeclarationsFlag
  }
`;
